/* eslint-disable eqeqeq */
import { useState, useEffect } from 'react';
import { useOutletContext, useParams } from 'react-router-dom';
import {
  Grid,
  Radio,
  styled,
  FormLabel,
  RadioGroup,
  FormControl,
  FormControlLabel,
  LinearProgress,
  Box,
  Typography,
} from '@mui/material';
import { getVideoById } from './Resources';
import visibilities from '../../utils/visibilities';
import { useAppProviderStore } from 'store/appProviderCopyStore';
import { videoFormValidation } from '../../utils/videoFormValidationUtils';
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';
import { mediaAPI } from 'services/admin';

function StepSeven(props) {
  const {
    setIsLoading,
    setNotify,
    videoMainUploadProgress,
    trailerUploadProgress,
    videoAcessibilityUploadProgress,
    legendaTrailerUploadProgress,
    audioTrailerUploadProgress,
    legendaAccessibilityUploadProgress,
    audioMainUploadProgress,
  } = useAppProviderStore();
  const {
    setValue,
    getValues,
    viewFields,
    videoResponse,
    setVideoResponse,
    formValidation,
  } = props;
  const params = useParams();
  const [showStatus, setShowStatus] = useState('');
  const [open, setOpen] = useState(false);
  const [visibility, setVisibility] = useState('');
  const [, setSelectedVisibilityLabel] = useState(null);
  const [auth, setAuth] = useOutletContext();
  const [userProfile, setUserProfile] = useState();
  const [, setNextContentSuggestion] = useState();
  const [disableButton, setDisableButton] = useState(false);

  const getMediaById = async (auth, mediaId) => {
    return new Promise((resolve, reject) => {
      const path = `/${mediaId}`;
      const session = auth;

      const data = {
        createdBy: {
          userId: session.getIdToken().payload.sub,
          name: session.getIdToken().payload.username,
        },
      };

      return mediaAPI
        .get(path, data)
        .then(resp => {
          resolve(resp);
        })
        .catch(error => {
          reject(error);
          console.log(error);
        });
    });
  };

  useEffect(() => {
    (async () => {
      let mediaId = getValues('mediaId');


      if (mediaId) {
        let responseMediaId = await getMediaById(auth, mediaId);

        if (responseMediaId?.status === 'CREATED') {
          setShowStatus(responseMediaId?.status);
          return;
        }
        if (responseMediaId?.status === 'COMPLETE') {
          setShowStatus(responseMediaId?.status);
        }
        if (responseMediaId?.status === 'DRAFTED') {
          setShowStatus(responseMediaId?.status);
          return;
        }
        if (responseMediaId?.status === 'ERROR') {
          setShowStatus(responseMediaId?.status);
          return;
        }
        let trailerId = getValues('trailerId');
        if (trailerId) {
          let responseTrailer = await getMediaById(auth, trailerId);
          if (responseTrailer?.status === 'CREATED') {
            setShowStatus(responseTrailer?.status);
            return;
          }
          if (
            responseMediaId?.status === 'COMPLETE' &&
            responseTrailer?.status === 'COMPLETE'
          ) {
            setShowStatus(responseMediaId?.status);
          }
        }
        let accessId = getValues('mediaWithAcessibilityId');
        if (accessId) {
          let responseAccessibility = await getMediaById(auth, accessId);
          if (
            responseAccessibility?.status === 'CREATED' &&
            responseAccessibility?.status !== null
          ) {
            setShowStatus(responseAccessibility?.status);
            return;
          }
          if (
            showStatus === 'COMPLETE' &&
            responseAccessibility?.status === 'COMPLETE'
          ) {
            setShowStatus(responseMediaId?.status);
          }
        }
      }
    })();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [viewFields]);

  useEffect(() => {
    setUserProfile(auth.getIdToken().payload['custom:user_profile']);
  }, [auth]);

  useEffect(() => {
    setOpen(open);

    console.log("Chegou aqui")
    console.log(videoResponse)
    // if (videoResponse?.visibility === undefined) {
    //   setVisibility(visibilities[0].name);
    //   setValue("visibility", visibilities[0].name);
    //   setSelectedVisibilityLabel(visibilities[0].value);
    // } else {}
    setVisibility(videoResponse?.visibility);
    setValue('visibility', videoResponse?.visibility);
    setVideoResponse(getValues());

    for (let item of visibilities) {
      if (videoResponse?.visibility === item.name) {
        setSelectedVisibilityLabel(item.value);
        setValue('visibility', item.name);
      }
    }

    if (videoResponse?.nextContentSuggestion?.contentId) {
      (async () => {
        let path = `/${params?.id}/versions/${params?.version}`;
        let suggestionResponse = await getVideoById(
          path,
          auth,
          setAuth,
          setIsLoading,
          setNotify
        );
        setNextContentSuggestion(suggestionResponse);
      })();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);
  
  useEffect(() => {
    if (["18", "A18"].includes(videoResponse?.ageRating)) {
      setDisableButton(true);
    } else {
      setDisableButton(false);
    }
  }, [videoResponse]);

  const verifyUpload = () => {
    if (
      videoMainUploadProgress?.percent > 0 &&
      videoMainUploadProgress?.percent < 100
    ) {
      return true;
    } else if (
      audioMainUploadProgress?.percent > 0 &&
      audioMainUploadProgress?.percent < 100
    ) {
      return true;
    } else if (
      trailerUploadProgress?.percent > 0 &&
      trailerUploadProgress?.percent < 100
    ) {
      return true;
    } else if (
      videoAcessibilityUploadProgress?.percent > 0 &&
      videoAcessibilityUploadProgress?.percent < 100
    ) {
      return true;
    } else if (
      legendaTrailerUploadProgress?.percent > 0 &&
      legendaTrailerUploadProgress?.percent < 100
    ) {
      return true;
    } else if (
      audioTrailerUploadProgress?.percent > 0 &&
      audioTrailerUploadProgress?.percent < 100
    ) {
      return true;
    } else if (
      legendaAccessibilityUploadProgress?.percent > 0 &&
      legendaAccessibilityUploadProgress?.percent < 100
    ) {
      return true;
    } else {
      return false;
    }
  };

  const BpIcon = styled('span')(({ theme }) => ({
    borderRadius: '50%',
    width: 16,
    height: 16,
    boxShadow:
      theme.palette.mode === 'dark'
        ? '0 0 0 1px rgb(16 22 26 / 40%)'
        : 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
    backgroundColor: theme.palette.mode === 'dark' ? '#394b59' : '#f5f8fa',
    backgroundImage:
      theme.palette.mode === 'dark'
        ? 'linear-gradient(180deg,hsla(0,0%,100%,.05),hsla(0,0%,100%,0))'
        : 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
    '.Mui-focusVisible &': {
      outline: '2px auto rgba(19,124,189,.6)',
      outlineOffset: 2,
    },
    'input:hover ~ &': {
      backgroundColor: theme.palette.mode === 'dark' ? '#30404d' : '#ebf1f5',
    },
    'input:disabled ~ &': {
      boxShadow: 'none',
      background:
        theme.palette.mode === 'dark'
          ? 'rgba(57,75,89,.5)'
          : 'rgba(206,217,224,.5)',
    },
  }));

  const BpCheckedIcon = styled(BpIcon)({
    backgroundColor: '#137cbd',
    backgroundImage:
      'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
    '&:before': {
      display: 'block',
      width: 16,
      height: 16,
      backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
      content: '""',
    },
    'input:hover ~ &': {
      backgroundColor: '#106ba3',
    },
  });

  function BpRadio(props) {
    return (
      <Radio
        disableRipple
        style={{ padding: 8 }}
        color="default"
        checkedIcon={<BpCheckedIcon />}
        icon={<BpIcon />}
        {...props}
      />
    );
  }

  const handleVisibilityChange = event => {
    const {
      target: { value },
    } = event;
    setVisibility(value);
    setValue('visibility', value);
    for (let item of visibilities) {
      if (value === item.name) {
        setSelectedVisibilityLabel(item.value);
      }
    }
  };

  return (
    <div className="step-container" id="step-six">
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <div className="video_label-title">Publicação</div>
        </Grid>
        <Grid item xs={12}></Grid>
        <FormControl id="video-visibility" style={{ marginLeft: '16px' }}>
          <FormLabel id="demo-radio-buttons-group-label" className="form-label">
            Visibilidade da publicação
          </FormLabel>
          <RadioGroup
            aria-labelledby="demo-radio-buttons-group-label"
            name="radio-buttons-group"
            onChange={handleVisibilityChange}
            value={visibility}
            id="video-visibility">
            <FormControlLabel
              disabled={viewFields}
              key={0}
              value="INTERNAL_USERS"
              control={<BpRadio />}
              label="Somente para usuários do Portal Admin do APP (para validação prévia - preview)"
              id="video-visibility-internal-user"
            />
            {userProfile === 'ADMIN' && (
              <FormControlLabel
                disabled={viewFields}
                key={1}
                value="AUTHENTICATED_USERS"
                control={<BpRadio />}
                label="Somente para usuários do APP logados"
                id="video-visibility-authentication-users"
              />
            )}
            {userProfile === 'ADMIN' && (
              <FormControlLabel
                disabled={viewFields || disableButton}
                key={2}
                value="EVERYONE"
                control={<BpRadio />}
                label="Todos usuários do APP (Logados e não-logados)"
                id="video-visibility-everyone"
              />
            )}
          </RadioGroup>
        </FormControl>
        {disableButton && (
          <Grid item xs={12}>
            <div className="video_label-title">
              <p style={{ fontSize: '15px' }}>
                * Conteúdo para maior de 18 anos, opção válida somente para usuários logados ou Preview
              </p>
            </div>
          </Grid>
        )}
        {verifyUpload() && (
          <Grid item xs={12}>
            <div className="video_label-title">
              <p style={{ fontSize: '15px' }}>
                Arquivos em processo de upload. Aguarde...
              </p>
            </div>

            <ul className="steps_resumo" id="video-summary">
              {videoMainUploadProgress?.percent > 0 &&
                videoMainUploadProgress?.percent < 100 && (
                  <li id="video-summary-title">
                    Vídeo:{' '}
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <Box sx={{ width: '100%', mr: 1 }}>
                        <label style={{ fontSize: '12px', color: 'blue' }}>
                          {videoMainUploadProgress?.name}
                        </label>
                        <LinearProgress
                          variant="determinate"
                          value={videoMainUploadProgress?.percent}
                          sx={{ width: '100%' }}
                        />
                      </Box>
                      <Box sx={{ minWidth: 35 }}>
                        <Typography variant="body2" color="text.secondary">
                          {videoMainUploadProgress?.percent}%
                        </Typography>
                      </Box>
                    </Box>
                  </li>
                )}
              {audioMainUploadProgress?.percent > 0 &&
                audioMainUploadProgress?.percent < 100 && (
                  <li id="video-summary-title">
                    Vídeo:{' '}
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <Box sx={{ width: '100%', mr: 1 }}>
                        <label style={{ fontSize: '12px', color: 'blue' }}>
                          {audioMainUploadProgress?.name}
                        </label>
                        <LinearProgress
                          variant="determinate"
                          value={audioMainUploadProgress?.percent}
                          sx={{ width: '100%' }}
                        />
                      </Box>
                      <Box sx={{ minWidth: 35 }}>
                        <Typography variant="body2" color="text.secondary">
                          {audioMainUploadProgress?.percent}%
                        </Typography>
                      </Box>
                    </Box>
                  </li>
                )}
              {trailerUploadProgress?.percent > 0 &&
                trailerUploadProgress?.percent < 100 && (
                  <li id="video-summary-title">
                    Trailer:{' '}
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <Box sx={{ width: '100%', mr: 1 }}>
                        <label style={{ fontSize: '12px', color: 'blue' }}>
                          {trailerUploadProgress?.name}
                        </label>
                        <LinearProgress
                          variant="determinate"
                          value={trailerUploadProgress?.percent}
                          sx={{ width: '100%' }}
                        />
                      </Box>
                      <Box sx={{ minWidth: 35 }}>
                        <Typography variant="body2" color="text.secondary">
                          {trailerUploadProgress?.percent}%
                        </Typography>
                      </Box>
                    </Box>
                  </li>
                )}
              {legendaTrailerUploadProgress?.percent > 0 &&
                legendaTrailerUploadProgress?.percent < 100 && (
                  <li id="video-summary-title">
                    Legenda(s) do trailer:{' '}
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <Box sx={{ width: '100%', mr: 1 }}>
                        <label style={{ fontSize: '12px', color: 'blue' }}>
                          {legendaTrailerUploadProgress?.name}
                        </label>
                        <LinearProgress
                          variant="determinate"
                          value={legendaTrailerUploadProgress?.percent}
                          sx={{ width: '100%' }}
                        />
                      </Box>
                      <Box sx={{ minWidth: 35 }}>
                        <Typography variant="body2" color="text.secondary">
                          {legendaTrailerUploadProgress?.percent}%
                        </Typography>
                      </Box>
                    </Box>
                  </li>
                )}
              {audioTrailerUploadProgress?.percent > 0 &&
                audioTrailerUploadProgress?.percent < 100 && (
                  <li id="video-summary-title">
                    Áudio do trailer:{' '}
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <Box sx={{ width: '100%', mr: 1 }}>
                        <label style={{ fontSize: '12px', color: 'blue' }}>
                          {audioTrailerUploadProgress?.name}
                        </label>
                        <LinearProgress
                          variant="determinate"
                          value={audioTrailerUploadProgress?.percent}
                          sx={{ width: '100%' }}
                        />
                      </Box>
                      <Box sx={{ minWidth: 35 }}>
                        <Typography variant="body2" color="text.secondary">
                          {audioTrailerUploadProgress?.percent}%
                        </Typography>
                      </Box>
                    </Box>
                  </li>
                )}
              {videoAcessibilityUploadProgress?.percent > 0 &&
                videoAcessibilityUploadProgress?.percent < 100 && (
                  <li id="video-summary-title">
                    Vídeo de linguagem de sinais:{' '}
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <Box sx={{ width: '100%', mr: 1 }}>
                        <label style={{ fontSize: '12px', color: 'blue' }}>
                          {videoAcessibilityUploadProgress?.name}
                        </label>
                        <LinearProgress
                          variant="determinate"
                          value={videoAcessibilityUploadProgress?.percent}
                          sx={{ width: '100%' }}
                        />
                      </Box>
                      <Box sx={{ minWidth: 35 }}>
                        <Typography variant="body2" color="text.secondary">
                          {videoAcessibilityUploadProgress?.percent}%
                        </Typography>
                      </Box>
                    </Box>
                  </li>
                )}
              {legendaAccessibilityUploadProgress?.percent > 0 &&
                legendaAccessibilityUploadProgress?.percent < 100 && (
                  <li id="video-summary-title">
                    Legendas vídeo de linguagem de sinais:{' '}
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <Box sx={{ width: '100%', mr: 1 }}>
                        <label style={{ fontSize: '12px', color: 'blue' }}>
                          {legendaAccessibilityUploadProgress?.name}
                        </label>
                        <LinearProgress
                          variant="determinate"
                          value={legendaAccessibilityUploadProgress?.percent}
                          sx={{ width: '100%' }}
                        />
                      </Box>
                      <Box sx={{ minWidth: 35 }}>
                        <Typography variant="body2" color="text.secondary">
                          {legendaAccessibilityUploadProgress?.percent}%
                        </Typography>
                      </Box>
                    </Box>
                  </li>
                )}
            </ul>
          </Grid>
        )}

        {viewFields && (
          <div style={{ marginLeft: '16px', marginTop: '16px' }}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <div className="video_label-title">Confirmação</div>
              </Grid>

              <Grid item xs={12}>
                {(showStatus === 'CREATED' ||
                  showStatus === 'TRANSCODING' ||
                  showStatus === 'ERROR') && ( // pelo menos uma mídia pending
                  <div
                    className="confirmation_message"
                    id="video-status-transcode-inprocess">
                    <svg
                      width="67"
                      height="67"
                      viewBox="0 0 67 67"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <rect
                        x="5.50391"
                        y="5.5"
                        width="56"
                        height="56"
                        rx="12"
                        fill="#F2F4F7"
                      />
                      <path
                        d="M37.1602 31.875C36.5586 31.875 36.1289 31.4453 36.1289 30.8438V26.0312V24.6562C36.1289 24.0977 36.5586 23.625 37.1602 23.625H39.9102C40.4688 23.625 40.9414 24.0977 40.9414 24.6562V26.0312C40.9414 26.6328 40.4688 27.0625 39.9102 27.0625H38.1914V30.8438C38.1914 31.4453 37.7188 31.875 37.1602 31.875ZM27.1914 27.0625C24.9141 27.0625 23.0664 28.9102 23.0664 31.1875V38.75C23.0664 39.1367 23.3672 39.4375 23.7539 39.4375H31.3164V31.1875C31.3164 28.9102 29.4688 27.0625 27.1914 27.0625ZM31.7891 27.0625C32.7773 28.1797 33.3789 29.6406 33.3789 31.1875V39.4375H43.0039C43.3477 39.4375 43.6914 39.1367 43.6914 38.75V31.1875C43.6914 29.7266 42.875 28.3945 41.6719 27.6641C42.0586 27.2344 42.3164 26.6758 42.3164 26.0312V25.6445C44.3359 26.6758 45.7539 28.7812 45.7539 31.1875V38.75C45.7539 40.2969 44.5078 41.5 43.0039 41.5H33.3789H31.3164H23.7539C22.207 41.5 21.0039 40.2969 21.0039 38.75V31.1875C21.0039 27.793 23.7539 25 27.1914 25H34.7539V26.0312V27.0625H31.7891ZM25.4727 30.5H28.9102C29.4688 30.5 29.9414 30.9727 29.9414 31.5312C29.9414 32.1328 29.4688 32.5625 28.9102 32.5625H25.4727C24.8711 32.5625 24.4414 32.1328 24.4414 31.5312C24.4414 30.9727 24.8711 30.5 25.4727 30.5Z"
                        fill="#344054"
                      />
                      <rect
                        x="5.50391"
                        y="5.5"
                        width="56"
                        height="56"
                        rx="12"
                        stroke="#F9FAFB"
                        strokeWidth="10"
                      />
                    </svg>
                    { videoResponse?.publishIn &&
                      videoResponse?.publishIn != '' ? (
                        <p>
                          Seu registro está em processamento e será{' '}
                          <strong>agendado</strong> para publicação no dia{' '}
                          <strong>
                            {new Date(videoResponse?.publishIn).toLocaleDateString(
                              'pt-BR',
                              { day: '2-digit', month: '2-digit', year: 'numeric' }
                            )}
                          </strong>
                        </p>
                      ) : (
                        <p>
                          Seu registro está em processamento e 
                          <strong>assim que for concluído enviaremos um e-mail com a confirmação </strong> 
                          da publicação no aplicativo
                        </p>
                      )
                    }
                  </div>
                )}
                {showStatus === 'COMPLETE' && ( // todas as mídias completed
                  <div
                    className="confirmation_message"
                    id="video-status-transcode-complete">
                    <svg
                      width="67"
                      height="67"
                      viewBox="0 0 67 67"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <rect
                        x="5.50391"
                        y="5.88965"
                        width="56"
                        height="56"
                        rx="12"
                        fill="#F2F4F7"
                      />
                      <path
                        d="M32.9453 37.249C32.4727 37.7217 31.7422 37.7217 31.2695 37.249L28.5195 34.499C28.0469 34.0264 28.0469 33.2959 28.5195 32.8232C28.9922 32.3506 29.7227 32.3506 30.1953 32.8232L32.1289 34.7139L36.7695 30.0732C37.2422 29.6006 37.9727 29.6006 38.4453 30.0732C38.918 30.5459 38.918 31.2764 38.4453 31.749L32.9453 37.249ZM44.5039 33.6396C44.5039 39.7412 39.5625 44.6396 33.5039 44.6396C27.4023 44.6396 22.5039 39.7412 22.5039 33.6396C22.5039 27.5811 27.4023 22.6396 33.5039 22.6396C39.5625 22.6396 44.5039 27.5811 44.5039 33.6396ZM33.5039 24.7021C28.5625 24.7021 24.5664 28.7412 24.5664 33.6396C24.5664 38.5811 28.5625 42.5771 33.5039 42.5771C38.4023 42.5771 42.4414 38.5811 42.4414 33.6396C42.4414 28.7412 38.4023 24.7021 33.5039 24.7021Z"
                        fill="#344054"
                      />
                      <rect
                        x="5.50391"
                        y="5.88965"
                        width="56"
                        height="56"
                        rx="12"
                        stroke="#F9FAFB"
                        strokeWidth="10"
                      />
                    </svg>
                    <p>
                      {videoResponse?.publishIn &&
                      videoResponse?.publishIn != '' ? 
                        (<>Seu registro já foi processado e está {' '}
                          <strong>agendado</strong> para publicação no dia{' '}
                          <strong>
                            {new Date(videoResponse?.publishIn).toLocaleDateString(
                              'pt-BR',
                              { day: '2-digit', month: '2-digit', year: 'numeric' }
                            )}
                          </strong></>) 
                          : (<>Seu registro já foi processado e<strong> concluído</strong>{' '}
                        e o vídeo <strong>já está disponível</strong> no
                        aplicativo</>)}
                    </p>
                  </div>
                )}
                {showStatus === 'ARCHIVED' && (
                  <div className="confirmation_message">
                    <svg
                      width="67"
                      height="67"
                      viewBox="0 0 67 67"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <rect
                        x="5.50391"
                        y="5.88965"
                        width="56"
                        height="56"
                        rx="12"
                        fill="#F2F4F7"
                      />
                      <path
                        d="M32.9453 37.249C32.4727 37.7217 31.7422 37.7217 31.2695 37.249L28.5195 34.499C28.0469 34.0264 28.0469 33.2959 28.5195 32.8232C28.9922 32.3506 29.7227 32.3506 30.1953 32.8232L32.1289 34.7139L36.7695 30.0732C37.2422 29.6006 37.9727 29.6006 38.4453 30.0732C38.918 30.5459 38.918 31.2764 38.4453 31.749L32.9453 37.249ZM44.5039 33.6396C44.5039 39.7412 39.5625 44.6396 33.5039 44.6396C27.4023 44.6396 22.5039 39.7412 22.5039 33.6396C22.5039 27.5811 27.4023 22.6396 33.5039 22.6396C39.5625 22.6396 44.5039 27.5811 44.5039 33.6396ZM33.5039 24.7021C28.5625 24.7021 24.5664 28.7412 24.5664 33.6396C24.5664 38.5811 28.5625 42.5771 33.5039 42.5771C38.4023 42.5771 42.4414 38.5811 42.4414 33.6396C42.4414 28.7412 38.4023 24.7021 33.5039 24.7021Z"
                        fill="#344054"
                      />
                      <rect
                        x="5.50391"
                        y="5.88965"
                        width="56"
                        height="56"
                        rx="12"
                        stroke="#F9FAFB"
                        strokeWidth="10"
                      />
                    </svg>
                    <p>
                      Seu registro já foi realizado e
                      <strong> incluído na coleção</strong>
                    </p>
                  </div>
                )}
              </Grid>
            </Grid>
          </div>
        )}
        {formValidation != undefined && formValidation.length > 0 && (
          <Grid
            item
            xs={13}
            sx={{ backgroundColor: '#ddedff', margin: 5, borderRadius: 6 }}>
            <Grid item xs={12}>
              <div
                className="video_label-title_validation"
                style={{ marginTop: 10 }}>
                Campos obrigatórios não preenchidos!
              </div>
              <div className="video_label-title_validation_2">
                Por favor, preencha os campos abaixo para que seja possível
                publicar seu vídeo:
              </div>
            </Grid>
            <div style={{ marginLeft: 15, marginBottom: 15 }}>
              {formValidation.map((items, index) => {
                return (
                  <li
                    key={index}
                    style={{ listStyleType: 'none', fontSize: 15 }}>
                    <ReportGmailerrorredIcon
                      fontSize="small"
                      sx={{ color: 'red' }}
                    />{' '}
                    {videoFormValidation[items]}
                  </li>
                );
              })}
            </div>
          </Grid>
        )}
      </Grid>
    </div>
  );
}

export default StepSeven;
